import React, { useState } from 'react';
import { useOutletContext } from "react-router-dom";
import { usePositionForm } from "../../../providers/PositionFormProvider";
import { PictureOutlined } from "@ant-design/icons";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";


const PositionBrands = props => {
    const { formModel: position, isProjectUpdating } = usePositionForm();
    const [value, setValue] = useState(undefined)
    const {
        isDisabled, isReadOnly, goBack, onSubmit, onChange
    } = useOutletContext();

    const selectBrand = async (brand) => {
        let brands = [...(position.brands || [])];
        console.log('selectBrand', brands);
        brands = TB.xorBy(brands, [brand], b => b.id || b.brandId);
        await onChange({ brands })
        setValue(undefined)
    }

    return (
        <div className="flex flex-col gap-[32px]">
            <div className="flex flex-col justify-start items-start self-stretch relative gap-4">
                <p className="self-stretch text-lg font-semibold text-left text-black">
                    {/* Associated Brands */}
                    Desired Brand or Company Experience
                </p>
                {/*{!position.industries?.length && (*/}
                {/*    <p className="self-stretch text-xs text-[#334d6e]">*/}
                {/*        No industries selected yet.*/}
                {/*    </p>*/}
                {/*)}*/}
                <p className="self-stretch text-xs text-[#334d6e]">
                    {/* Choose brands that talent has worked with in the past that may be important for this Role */}
                    Include the names of specific brands you want to search for when evaluating candidates, particularly those that would be appealing or relevant for this position
                </p>
                {position.brands?.length >= 10 && (
                    <div className="invalid-feedback flex text-muted">
                        Max limit reached for brands
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-4 items-stretch self-stretch relative">
                <div>
                    <SearchBrandsInput
                        key={`add-brand-${position?.brands?.length || 0}`}
                        value={value}
                        disabled={isDisabled || isReadOnly}
                        disabledOptions={TB.map(position?.brands, brand => brand.id || brand.brandId)}
                        onChange={brand => selectBrand(brand)} />

                    <p className="text-xs pl-3 pt-1.5 text-gray-500">
                        ex. Google, google.com
                    </p>
                </div>


                <div className="flex flex-row flex-wrap mt-2 gap-x-3 gap-y-5 mb-3">
                    {TB.map(position.brands || [], (brand, index) => {

                        return (
                            <div key={`brand-${index}-${brand.id || brand.brandId}`}
                                className="bg-gray-50 inline-flex flex-row justify-start items-center relative gap-3 py-3 pl-4 pr-8 min-w-[200px] border h-28">

                                <div className="flex items-center justify-start">
                                    {(brand.logo || brand.icon) ?
                                        <img className="h-full max-h-20 w-full max-w-32 object-contain" src={brand.logo || brand.icon}
                                            alt={brand.name} /> : (
                                            <PictureOutlined className="w-full max-w-full" style={{ fontSize: 56 }} />
                                        )}
                                </div>

                                <div className="flex flex-col flex-grow gap-1">
                                    <p className="text-base">{brand.name || brand.domain}</p>
                                    {brand.name && brand.domain && (
                                        <p className="text-xs text-info whitespace-nowrap">
                                            {brand.domain}
                                        </p>
                                    )}
                                </div>
                                {!isDisabled && !isReadOnly && (
                                    <div onClick={e => {
                                        return selectBrand(brand)
                                    }} className="absolute top-[3px] right-[3px] clickable">
                                        <i className="fa fa-times-circle self-start" />
                                    </div>
                                )}

                            </div>
                        )
                    })}
                </div>

            </div>
        </div>
    );
};

PositionBrands.propTypes = {};

export default PositionBrands;